import { ColumnMappingType } from "../../types/results";

const DEFAULT_COL_WIDTH = 80;
const MEDIUM_COL_WIDTH = 145;
const WIDE_COL_WIDTH = 185; // fits longest player display name at 24 characters

export type RunColumnKeyType = 'gameType' |
                             'gameDate' | 
                             'result' |
                             'teamName' |
                             'opponentName' |
                             'points' |
                             'startScore' |
                             'endScore' |
                             'firstPoint' |
                             'lastPoint'
                             ;

export const RUN_COLUMNS: { [key in RunColumnKeyType]: ColumnMappingType } = {
  gameDate: {
    headerName: 'Game Date',
    field: 'game__date',
    width: MEDIUM_COL_WIDTH,
    display: 'alwaysFirst',
  },
  gameType: {
    headerName: 'Game Type',
    field: 'game_type',
    width: MEDIUM_COL_WIDTH,
    display: 'alwaysFirst',
  },
  result: {
    headerName: 'Result',
    field: 'result',
    width: WIDE_COL_WIDTH,
    display: 'alwaysFirst',
    sortable: false,
  },
  teamName: {
    headerName: 'Team',
    field: 'team',
    width: DEFAULT_COL_WIDTH,
    display: 'alwaysFirst',
    colSpan: ({ row }) => {
      if (row.parentId) {
        return 2;
      }
      return 1;
    }
  },
  opponentName: {
    headerName: 'Opponent',
    field: 'opponent',
    width: DEFAULT_COL_WIDTH,
    display: 'alwaysFirst',
  },
  points: {
    headerName: 'PTS',
    field: 'points',
    width: MEDIUM_COL_WIDTH,
    display: 'alwaysFirst',
  },
  startScore: {
    headerName: 'Start Score',
    field: 'score_at_start',
    width: MEDIUM_COL_WIDTH,
    display: 'alwaysFirst',
    sortable: false,
  },
  endScore: {
    headerName: 'End Score',
    field: 'score_at_end',
    width: MEDIUM_COL_WIDTH,
    display: 'alwaysFirst',
    sortable: false,
  },
  firstPoint: {
    headerName: 'First Point',
    field: 'first_point',
    width: MEDIUM_COL_WIDTH,
    display: 'alwaysFirst',
    sortable: false,
  },
  lastPoint: {
    headerName: 'Last Point',
    field: 'last_point',
    display: 'alwaysFirst',
    sortable: false,
    flex: 1,
    minWidth: MEDIUM_COL_WIDTH,
  },
};
